import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../../public/styles/HomeInteriors/homepage/HomeBanner.scss";
import apiManager from "../../../utils/apiManager";
import { espotAPI, imagePrefix } from "../../../../public/constants/constants";

export default class HomeBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: "GI_Interiors_HomeBanner",
      homeSlider: null,
      isLoading: false,
      error: null,
      title: "",
      description: "",
      type: "",
    };
    this.isScrolling = true;

    this.homeSlider = React.createRef();
  }

  gethomeBannerData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const { data } = response || {};
        this.setState({
          homeSlider: data && data.data.bannerList,
          title: data && data.data.title,
          description: data && data.data.desc,
          type: data && data.data.type,
          isLoading: false,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  scrollTOForm() {
    document.getElementById("HIConsultForm").scrollIntoView({
      behavior: "smooth",
    });
  }

  componentDidMount() {
    this.gethomeBannerData();
    document.addEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("touchstart", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    document.addEventListener("touchstart", this.handleClickOutside);
  }

   HI_HomepageLoad(index){
    if(index==0)
      {
        let HI_homepageload_event = new Event("HI_homepageload_event",{ bubbles: true,});
        HI_homepageload_event.simulated = true;
        document.dispatchEvent(HI_homepageload_event);
      }
  }


  render() {
    const { homeSlider } = this.state;
    const settings = {
      dots: true,
      lazyLoad: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 2,
      prevArrow: false,
      nextArrow: false,
      autoplay: false /* this is the new line */,
      autoplaySpeed: 5000,
      arrows: false,
    };
    return (
      <div className="home-banner-container">
        {/* <Slider {...settings}>
                <div>
                    <img className="banner-image1" alt= "interior-banner-image1" src= {bannerimg1}></img>
                </div>
                <div>
                    <img className="banner-image2" alt= "interior-banner-image2" src= {bannerimg2}></img>
                </div>
                <div>
                    <img className="banner-image3" alt= "interior-banner-image3" src= {bannerimg3}></img>
                </div>
            </Slider> */}

        <div className="slider-overlay-window">
          <Slider {...settings} className="videoBanner">
            {!!homeSlider &&
              homeSlider.map((sliderData, index) => (
                <>
                  {/* <a key={index}>
                    <a
                      onClick={e => this.handleOnClick(e)}
                      onMouseDown={e => this.handleOnClick(e)}
                      href={`${sliderData.onClickUrl}`}
                    > */}
                  <img
                    src={`${imagePrefix}${sliderData.imageSrc}`}
                    className="img-fluid"
                    alt={sliderData.alt}
                     onLoad={this.HI_HomepageLoad(index)}
                  />

                  {/* </a>
                  </a> */}
                </>
              ))}
          </Slider>
          <div className="overlay-banner" />
          <div className="banner-overlay-text">
            <h2 className="banner-title">
              WELCOME TO <br /> GODREJ INTERIO HOME INTERIORS
            </h2>
            <span className="banner-sub-title">
              Your dream home interiors,
              <br /> created exactly the way you imagined it.
            </span>
            <br />
            {/* <div> */}
            <button className="button-book-consult" onClick={this.scrollTOForm}>
              BOOK A CONSULTATION
            </button>
            {/* </div> */}
          </div>
        </div>
      </div>
    );
  }
}
